/**
 * created by xcc
 融媒号 同步投稿至其他单位及媒体
 *
 */
import React from 'react';
import {Icon, Input, Tree, message} from 'antd'
import '../../../editor/components/EditorPublishInformation.css';
import BaseComponent from "../../../../base/BaseComponent";
import folder from "./folder.png"

const {TreeNode} = Tree;
const {Search} = Input;
const getNodesUrl = "/cm-sites-pms/contribute/nodes";
const collectUrl = "/cm-sites-pms/contribute/collect";
const cancelCollectionUrl = "/cm-sites-pms/contribute/cancel";
export default class RmSynchronousContribute extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute: true,
            properties: true,
            orso: true,
            switchShow: false,
            // 搜索框内容
            searchText: "",
            // 展开的节点树
            expandedKeys: [],
            // 搜索到的key
            searchExpandedKeys: [],
            // 展开的节点
            selectedKeys: [],
            // 选中的节点
            checkedKeys: [],
            publishInformation: {
                currentColumn: [],//当前栏目
                numerical: '',//重要性
                location: '',//显示位置
                frequency: '',//点击次数
                accretion: [],//同步数据
            },
            treeData: [],
            filterCheckedKeys: true, // 是否过滤选中的节点
        }
    }

    componentWillMount() {
        this.getNodes((treeData)=>{
            // 解决setData比当前回调快导致无法回显已选节点的问题
            let checkedKeys = this.state.checkedKeys;
            let newCheckedKeys = [];
            this.formatBySetData({checkedKeys,newCheckedKeys,treeData});
            this.setState({
                checkedKeys: newCheckedKeys
            })
        })
    }

    componentDidMount() {
    }

    getData = () => {
        if (this.state.filterCheckedKeys) {
            let newCheckedKeys = [];
            if (this.state.treeData && this.state.treeData.length) {
                this.findCheckedKeys({
                    treeData: this.state.treeData,
                    newCheckedKeys,
                    checkedKeys: this.state.checkedKeys
                })
            }
            return newCheckedKeys
        }
        return this.state.checkedKeys
    };

    getDetails = () => {
        let newCheckedKeys = [];
        if (this.state.treeData && this.state.treeData.length) {
            this.findCheckedKeysByDetails({
                treeData: this.state.treeData,
                newCheckedKeys,
                checkedKeys: this.state.checkedKeys
            })
        }
        return newCheckedKeys
    };

    findCheckedKeysByDetails = ({treeData, newCheckedKeys, checkedKeys}) => {
        if (treeData && treeData.length) {
            treeData.forEach(item => {
                if (checkedKeys.includes(item.id) && !newCheckedKeys.some(k=>k.id===item.id)) {
                    newCheckedKeys.push(item)
                }
                if (item.child && item.child.length) {
                    this.findCheckedKeysByDetails({treeData: item.child, newCheckedKeys, checkedKeys})
                }
            })
        } else {
            return newCheckedKeys
        }
    };

    findCheckedKeys = ({treeData, newCheckedKeys, checkedKeys}) => {
        if (treeData && treeData.length) {
            treeData.forEach(item => {
                if (checkedKeys.includes(item.id) && !newCheckedKeys.includes(item.id)) {
                    newCheckedKeys.push(item.id)
                }
                if (item.child && item.child.length) {
                    this.findCheckedKeys({treeData: item.child, newCheckedKeys, checkedKeys})
                }
            })
        } else {
            return newCheckedKeys
        }
    };

    setData = (checkedKeys) => {
        let newCheckedKeys = [];
        let treeData = this.state.treeData;
        this.formatBySetData({checkedKeys,newCheckedKeys,treeData});
        this.setState({
            checkedKeys: newCheckedKeys
        })
    };

    // 对回显数据进行过滤审查，主要解决投稿过程中部门下媒体发生改变的问题
    formatBySetData = ({checkedKeys,newCheckedKeys,treeData}) => {
        if(
            !checkedKeys?.length
        ) {
            return
        }
        if(!treeData?.length) {
            checkedKeys.forEach(checkedKey=>{
                newCheckedKeys.push(checkedKey);
            });
            return;
        }
        checkedKeys.forEach(checkedKey=>{
            let checkedItem = {data:null};
            this.findCheckedItem({checkedKey,treeData,checkedItem});
            if(checkedItem?.data) {
                let isCheckedALLByChild = {check:true};
                this.isCheckedALLByChild({isCheckedALLByChild,checkedItem:checkedItem.data,checkedKeys});
                if(isCheckedALLByChild?.check && newCheckedKeys.every(newCheckedKey=>newCheckedKey!==checkedKey)) {
                    newCheckedKeys.push(checkedKey)
                }
            }
        })
    };

    // 给定一个key，找到对应的节点
    findCheckedItem = ({checkedKey,treeData,checkedItem}) => {
        if (treeData && treeData.length && checkedKey?.length) {
            treeData.forEach(item => {
                if(checkedKey === item.id) {
                    checkedItem.data = item;
                } else if(item?.child?.length) {
                    this.findCheckedItem({treeData: item.child,checkedKey,checkedItem})
                }
            })
        }
    };

    // 判断当前选中节点的子节点是否全部选中了
    isCheckedALLByChild = ({isCheckedALLByChild,checkedItem,checkedKeys}) => {
        if(checkedItem.child?.length) {
            checkedItem.child.forEach(item=>{
                if(checkedKeys.every(checkedKey=>checkedKey!==item.id)) {
                    isCheckedALLByChild.check = false;
                } else if(item?.child?.length) {
                    this.isCheckedALLByChild({isCheckedALLByChild,checkedItem:item?.child,checkedKeys})
                }
            })
        }
    };

    getNodes = (call) => {
        this.request({
            url: getNodesUrl,
            callBack: (res) => {
                let treeData = [];
                if (res) {
                    treeData = res;
                }
                call&&call(treeData);
                this.setState({treeData})
            },
            errorCallBack: (e) => {
                call&&call([]);
                this.setState({treeData: []})
            }
        })
    };

    render() {
        const {contribute, treeData} = this.state;
        let floor = 0;
        // 网站写稿是同步投递，投稿稿件新增是直接投稿不存在同步
        let title = this.props.dynamicParams ? "同步投稿至" : "投稿至";
        return (
            <>
                <div className="synchronize">
                    <div className="overstriking">{title}</div>
                    <div><Icon className="lineIcon" type={contribute ? "down" : "up"}
                               onClick={this.contributeTree}/>
                    </div>
                </div>
                <Search
                    placeholder="请输入关键词"
                    onSearch={value => this.onChange(value)}
                    style={{margin: "10px 0"}}
                />
                {contribute ?
                    <div>
                        <Tree
                            showIcon
                            checkable
                            defaultExpandParent={true}
                            defaultExpandAll={true}
                            expandedKeys={this.state.expandedKeys}
                            autoExpandParent={this.state.autoExpandParent}
                            checkedKeys={this.state.checkedKeys}
                            selectedKeys={[]}
                            onExpand={this.onExpand}
                            onSelect={this.onSelect}
                            onCheck={this.onCheck}
                            selectable={false}
                        >
                            {this.renderTreeNodes(treeData, floor)}
                        </Tree>
                    </div> : ''
                }
            </>
        )
    }

    renderTreeNodes = (data, floor) =>
        data.map(item => {
            let type = item.type === "dept" ? folder : null;
            if (item.child) {
                return (
                    <TreeNode title={this.renderTitle(type, item, floor)} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.child, floor + 1)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderTitle(type, item, floor)}/>;
        });

    renderTitle = (type, item, floor) => {
        const index = this.state.searchText.length > 0 ? item.name.indexOf(this.state.searchText) : -1;
        let width1 = 190 - floor * 19;
        let width2 = 190 - floor * 19 - (type ? 8 + 16 : 0) - 14 - 10;// 减去左右图标和中间空隙
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div title={item.name} style={{display: "flex", alignItems: "center"}}>
                    {type ? <img src={type} style={{width: 16, marginRight: 8}}/> : null}
                    <span style={{
                        width: width2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        color: index > -1 ? '#f50' : 'unset'
                    }}
                    >{item.name}</span>
                </div>
                <div onClick={(e) => {
                    e.stopPropagation();
                    this.setCollect(item)

                }}>{item.collect ? <Icon title={'点击取消收藏'} type="star" theme="filled" style={{color: "#f0a738"}}/> :
                    <Icon title={'点击收藏'} type="star"/>}</div>
            </div>
        )
    };

    //搜索框输入变化的时候调用为提高性能，去掉了输入内容变化后调用改为点击搜索或者enter调用
    onChange(textValue) {
        if (textValue.length < 0) {
            this.state.expandedKeys = []
        }
        {
            this.state.searchExpandedKeys = [];
            this.getSearchOpenKey(this.state.treeData, textValue)
        }
        this.state.autoExpandParent = true;
        this.setState({searchText: textValue, expandedKeys: this.state.searchExpandedKeys})
    }

    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.name.indexOf(searchText) : -1;
                if (index > -1) {
                    //if(item[childKey]&&item[childKey].length>0){
                    this.state.searchExpandedKeys.push(item["id"])
                    /* let keyIdArry=item[keyId].split('-')
                     keyIdArry.forEach((i)=>{
                        this.state.searchExpandedKeys.push(i)
                     })*/
                    // }
                }
                this.getSearchOpenKey(item["child"], searchText)
            })
        }
    }

    contributeTree = () => {
        const {contribute} = this.state;
        this.setState({
            contribute: !contribute,
        })
    }

    setCollect = (item) => {
        let url = "";
        if (item.collect) { // 取消收藏
            url = cancelCollectionUrl;
        } else { // 收藏
            url = collectUrl;
        }
        this.request({
            url: url,
            body: {nodeId: item.id},
            method: "post",
            callBack: (res) => {
                this.getNodes()
            },
            errorCallBack: (e) => {
                message.error(e)
            }
        })
    };

    onSelect = (selectedKeys, info) => {
        const titleeName = [];
        this.setState({selectedKeys});
    };

    onCheck = (checkedKeys, info) => {
        const titleeName = [];
        info.checkedNodes.forEach(item => {
            titleeName.push(item.props.title);
        });
        console.log('onCheck', checkedKeys, info);
        this.setState({
            titleeName: titleeName,
            checkedKeys
        })

    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

}